var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLongDownE1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C12.2089 22.75 12.4084 22.6629 12.5503 22.5096L17.5503 17.1096C17.7529 16.8908 17.8066 16.5729 17.6873 16.2997C17.5679 16.0266 17.2981 15.85 17 15.85H12.75V2.75H17C17.4142 2.75 17.75 2.41421 17.75 2C17.75 1.58579 17.4142 1.25 17 1.25H7C6.58579 1.25 6.25 1.58579 6.25 2C6.25 2.41421 6.58579 2.75 7 2.75H11.25V15.85H7.00002C6.70191 15.85 6.4321 16.0266 6.31275 16.2997C6.1934 16.5729 6.24716 16.8908 6.4497 17.1096L11.4497 22.5096C11.5916 22.6629 11.7911 22.75 12 22.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongDownE1);
export default __webpack_public_path__ + "static/media/arrow-long-down-e-1.734b39e71f386c7083a9d8f43f1ba819.svg";
export { ForwardRef as ReactComponent };